import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import { StyleContext } from '../../context/StyleContext';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TiStarFullOutline } from "react-icons/ti";
import ModalCadastrarCapacidade from './ModalCadastrarCapacidade';

function ModalArvoreCapacidade({ setAbreModal }) {
    const { ListaArvoreCapacidades, ArvoreCapacidades, loading, Permissao } = useContext(ApiContext)
    const { btnCriar, theme } = useContext(StyleContext)

    const [keyArvore, setKeyArvore] = useState('')
    const [descricaoArvore, setDescricaoArvore] = useState('')
    const [openModal, setopenModal] = useState(false)

    useEffect(() => {
        ListaArvoreCapacidades()
    }, [])

    const processarDataSource = (data) => {
        if (!Array.isArray(data)) return [];

        return data.map(item => {
            const filhosProcessados = item.filhos ? processarDataSource(item.filhos) : [];

            const algumFilhoTemDominio = filhosProcessados.some(f => f.temDominio);
            const temDominio = item.dominio || algumFilhoTemDominio;

            return {
                ...item,
                titulo: item.nivel ? `${item.nivel} - ${item.titulo}` : item.titulo,
                temDominio,
                filhos: filhosProcessados
            };
        });
    };

    const dataSourceTransformado = processarDataSource(ArvoreCapacidades);

    const renderTree = (node) => (
        <TreeItem
            key={node.key}
            itemId={node.key}
            label={
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span>{node.titulo}</span>

                    <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="tooltip-dominio">Capacidade definida como Domínio</Tooltip>}
                    >
                        <span>
                            {node.temDominio && <TiStarFullOutline style={{ color: "#f5b400" }} />}
                        </span>
                    </OverlayTrigger>
                </div>
            }
        >
            {Array.isArray(node.filhos) &&
                node.filhos.map((child) => renderTree(child))}
        </TreeItem>
    );

    const handleSelect = (event, itemId) => {
        const buscar = (lista) => {
            for (const item of lista) {
                if (item.key === itemId) return item;
                if (item.filhos) {
                    const encontrado = buscar(item.filhos);
                    if (encontrado) return encontrado;
                }
            }
            return null;
        };

        const selecionado = buscar(dataSourceTransformado);

        setKeyArvore(selecionado?.key)
        setDescricaoArvore(selecionado?.titulo)
    };

    return (
        <div className="modal-criar-demanda">
            {openModal &&
                <ModalCadastrarCapacidade
                    setopenModal={setopenModal}
                    keyArvore={keyArvore}
                    descricaoArvore={descricaoArvore}
                    setKeyArvore={setKeyArvore}
                />
            }

            <div className="modal-criar-ciclo-interno">
                {loading &&
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                }

                <div className="header-modal-criar-demanda">
                    <h1 className="h1-modal">Árvore Capacidades de Negócio da Demanda</h1>

                    <div className="btn-close-modal" onClick={() => setAbreModal(false)}>
                        <FaTimes />
                    </div>
                </div>

                <div className="modal-content-criar-demanda">
                    <div style={{ position: 'fixed', width: '58%', display: 'flex', justifyContent: 'end', zIndex: 2 }} className='container-btn-arvore'>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setopenModal(true)}>
                                <FaPlus style={{ marginRight: 10 }} />Novo
                            </button>
                        }
                    </div>

                    <SimpleTreeView
                         sx={{
                            marginTop: "30px",
                            color: theme === 'dark' ? "#3f3f46" : "#fff"
                        }}
                        onSelectedItemsChange={handleSelect}
                    >
                        {dataSourceTransformado.map((node) => renderTree(node))}
                    </SimpleTreeView>
                </div>
            </div>
        </div>
    )
}

export default ModalArvoreCapacidade;
